/**
 * `v3.loops.*` — saved loops, for members (Clerk session or `ocl_` token), scoped to the
 * caller's customer. Payloads and results are `@fm/v3`'s.
 *
 * Handlers: `v3-loops.router.ts` (A-LOOPS).
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { LoopDefineInput, LoopDetail, LoopListInput, LoopRef, LoopSummary } from "@fm/v3/api";
import { Schema } from "effect";
import { DatabaseError, Forbidden, RecordNotFoundError, Unauthorized, ValidationError } from "../errors.ts";
import { LoopActorMiddleware } from "../loop-actor.tags.ts";

const errors = Schema.Union(Unauthorized, Forbidden, RecordNotFoundError, ValidationError, DatabaseError);

/**
 * @since 1.0.0
 */
export class V3LoopRpcs extends RpcGroup.make(
  Rpc.make("v3.loops.list", { payload: LoopListInput, success: Schema.Array(LoopSummary), error: errors })
    .middleware(LoopActorMiddleware),
  Rpc.make("v3.loops.get", { payload: LoopRef, success: LoopDetail, error: errors }).middleware(LoopActorMiddleware),
  /** A definition failing `validateLoopDefinition` is a ValidationError listing every problem. */
  Rpc.make("v3.loops.define", { payload: LoopDefineInput, success: LoopDetail, error: errors })
    .middleware(LoopActorMiddleware),
  Rpc.make("v3.loops.archive", { payload: LoopRef, success: LoopSummary, error: errors })
    .middleware(LoopActorMiddleware),
) {}
